import React from 'react'
import type { ReactNode } from 'react'

import './WebinarSidebarSecondaryPanelComponent.scss'

interface WebinarSidebarSecondaryPanelProps {
  children: ReactNode
}

const WebinarSidebarSecondaryPanelComponent = ({
  children,
}: WebinarSidebarSecondaryPanelProps) => {
  return (
    <div className="webinar-sidebar-secondary-panel-component">
      <div className="secondary-panel-body">{children}</div>
    </div>
  )
}

export default WebinarSidebarSecondaryPanelComponent
